/** Hover text on the disabled Upload Files and Add Device Manually options (UAC §1, proposed copy). */
export const CANCELED_SHIPMENT_TEMP_DATA_MESSAGE =
  "Temperature data can't be added to a canceled shipment."

const CANCELED_VALUES = new Set(['cancelled', 'canceled'])

const isCanceledValue = (value) => CANCELED_VALUES.has(String(value ?? '').toLowerCase())

/**
 * A canceled shipment is locked for new temperature data (UAC §1, Locked shipments). Command
 * Center's Cancel Shipment sets `shipment_primary_state`; Product Release reads `review_progress`.
 * @param {{ shipment_primary_state?: string | null, review_progress?: string | null } | null | undefined} shipment
 * @returns {boolean} Whether the shipment is canceled.
 */
export function isShipmentCanceled(shipment) {
  return (
    isCanceledValue(shipment?.shipment_primary_state) || isCanceledValue(shipment?.review_progress)
  )
}
